import 'core-js';
import './public-path';
import * as React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from '@/stores';
import '@/assets/styles/app.less';

console.log('app entry');

if (window.__MICRO_APP_ENVIRONMENT__) {
  store.setMicroConfig(window.microAppConfig);
  store.setAppConfig(window.appConfig);
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <App />
);

document.getElementById('root')?.parentElement?.addEventListener('keydown', (e: KeyboardEvent) => {
  if (e.key =='Enter') {
    if (e.target instanceof HTMLElement && e?.target?.nodeName == 'BUTTON') {
      e.preventDefault();
      return false;
    }
  }
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
